import { useForm } from "../../../providers/FormProvider";
import NotFoundPage from "../error/NotFoundPage";
import LoadingPage from "../states/LoadingPage";
import { MissionFormEnums } from "../../../common/constants";
import AdvancedFormPage from "../advancedform/AdvancedFormPage";
import EasyFormPage from "../easyform/EasyFormPage";

export default function FormRootPage() {
  const { loading, notFound, form } = useForm();

  return notFound ? (
    <NotFoundPage />
  ) : loading || !form ? (
    <LoadingPage />
  ) : form.formType === MissionFormEnums.FormType.AdvancedForm ? (
    <AdvancedFormPage />
  ) : (
    <EasyFormPage />
  )
}
